module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_5_CLICKED.5cc39186.svg";